<template>
  <div>
    <table class="table table-bordered table-condensed table-striped table-hover relatorio">
      <tr>
        <th scope="col" class="col-4">Apresentação da Opção</th>
        <th scope="col" class="col-4">Rótulo</th>
      </tr>
      <tr>
        <td>
          <fcc-select
            label-field="descricao"
            value-field="tpapresentacaoopcao"
            v-model="apresentacao"
            :options="listaApresentacaoDasOpcoes"
            :clearable="false"
          />
        </td>
        <td>
          <fcc-input v-model="rotulo" />
        </td>
      </tr>
    </table>
    <div class="text-right mb-3">
      <fcc-button @click="buscar" :disabled="!apresentacao || !rotulo">{{
        labelsSystem.buscar
      }}</fcc-button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['listaApresentacaoDasOpcoes'],
  data() {
    return {
      apresentacao: '',
      rotulo: 'Cargo'
    }
  },
  methods: {
    buscar() {
      this.$emit('buscar', this.apresentacao, this.rotulo)
    }
  }
}
</script>